import React, {useState, useEffect, useContext} from "react";
// import Link from "next/link";
import { Button } from "@chakra-ui/button";
import { useSession } from "next-auth/react";
import { removeDuplicates } from "utils/tweetUtils";
import { useColorModeValue, useColorMode } from "@chakra-ui/color-mode";
import {
    Box,
    Flex,
    Text,
    useMediaQuery,
    useDisclosure,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    Image,
    Center,
    Link,
    Tabs,
    Tab,
    TabList,
    TabPanel,
    TabPanels,
} from "@chakra-ui/react";
import { firebaseClient, getToken } from "firebaseClient";
import { useRouter } from "next/dist/client/router";
import { ChevronDownIcon } from '@chakra-ui/icons';
import { useFirebaseUser } from "../../utils/useFirebaseUser";
import { TweetBar } from "components/queue-panels/tweet-bar";
import PuffLoader from "react-spinners/PuffLoader";
import { TweetContext } from "context/tweetContext";
import { CreatorListItem } from "components/scheduler/creatorListItem";
import { fetchContracts } from "controllers/ghostController";

export const GhostwriterAllContent = ({selectedCreator, setSelectedCreator}) => {

    const { colorMode, toggleColorMode } = useColorMode();
    const router = useRouter();
    const { data: session, status } = useSession() ?? {}
    const loading = status === "loading"
    const isAuthenticated = useFirebaseUser();
    const [isTooSmall] = useMediaQuery("(max-width: 600px)");

    const [isUpdating, setIsUpdating] = React.useState(false);
    const [twUserName, setTwUserName] = React.useState("");
    const [reviews, setReviews] = React.useState<any>([]);

    const { isOpen, onOpen, onClose } = useDisclosure();
    const [isLoading, setIsLoading] = React.useState(false);
    const [refresh, refresher] = React.useState({});

    const [tweetsPending, setTweetsPending] = useState<any[]>([]);
    const [tweetsReady, setTweetsReady] = useState<any[]>([]);
    const [tweetsRejected, setTweetsRejected] = useState<any[]>([]);
    const [tweetsPublished, setTweetsPublished] = useState<any[]>([]);
    const [tweets, setTweets] = useState<any[]>([]);
    const [tweetsFiltered, setTweetsFiltered] = useState<any[]>([]);
    const tweetContext: any = useContext(TweetContext);
    
    const [contracts, setContracts] = React.useState<any>([]);
    const [clients, setClients] = React.useState([]);

    const getTweets = async function () {
        setIsLoading(true);
        // const response = await fetch('/api/ghostwriting/getWritingTweets?id=' + session?.user?.uid, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json',
        //     },
        //     body: JSON.stringify({
        //         tokenUserId: session?.user?.uid,
        //         token: await getToken(session, "getGhostwriters"),
        //     }),
        // });
        // const json = await response.json();
        // console.log(json);

        const db = firebaseClient.firestore();
        let docs = await db.collectionGroup("tweets").where("ghostwriterId", "==", session?.user?.uid).get();
        let tweets = docs.docs.map(x => x.data());

        // console.log("getTweets - org: " + session?.user?.data?.subscription?.org);
        if (session?.user?.data?.subscription?.org && session?.user?.data?.subscription?.orgRole !== "Member") {
            let docsOrg = await db.collectionGroup("tweets").where("ghostwriterIdOrg", "==", session?.user?.data?.subscription?.org).get();
            let tweetsOrg = docsOrg.docs.map(x => x.data());
            tweets = tweets.concat(tweetsOrg);
        }
        
        console.log('tweets:', tweets);
        tweets = removeDuplicates(tweets, "id");

        tweets.forEach(tw => {
            if (tw.statusGhost === "rejected") tw.priority = 3;
            else if (tw.statusGhost === "pending") tw.priority = 1;
            else if (tw.statusGhost === "done") tw.priority = 0;
            else tw.priority = 2;
        });

        // sort by statusGhost
        tweets = tweets.sort((a, b) => b.priority - a.priority);


        if (tweets?.length) {
            // setTweetsPending(tweets.filter(x => x.statusGhost == "pending"));
            // setTweetsReady(tweets.filter(x => x.statusGhost == "ready"));
            // setTweetsRejected(tweets.filter(x => x.statusGhost == "rejected"));
            // setTweetsPublished(tweets.filter(x => x.statusGhost == "done" || x.status == "sent" || x.status == "scheduled"));
            // tweets = [];
            setTweets(tweets);
            filterTweets(tweets);
        }
        setIsLoading(false);
    }

    const filterTweets = function (tweets) {
        let filtered = tweets;
        if (selectedCreator?.id) {
            filtered = tweets.filter(x => x.idAccount == selectedCreator.id);
        }
        setTweetsFiltered(filtered);
    }

    useEffect(() => {
        if (isAuthenticated) {
            let accounts = session?.user?.data?.linkAccounts ?? [];
            // accounts = accounts.concat(session?.user?.linkAccounts ?? []);
            // console.log('accounts:', accounts);
            setClients(accounts);
            getTweets();
            // getContracts();
        }
    }, [isAuthenticated, tweetContext.refresh]);

    useEffect(() => {
        filterTweets(tweets);
    }, [selectedCreator]);


    // console.log(countryList());
    // console.log("-" + data.country + "-");

    let selectedCreatorContract = contracts?.find(c => c?.client?.id == selectedCreator?.id && c.status == "running");
    let name = selectedCreator?.name ?? "@" + selectedCreator?.twUserName;

    return (
        <Box>
            {
                tweets?.length > 0 && (
                    <Flex justifyContent="space-between" alignItems="center" w="100%" mt="4" pb={4}>
                        <Flex>
                            <Menu>
                                <MenuButton
                                    as={Button}
                                    mr={3}
                                    variant="ghost"
                                    rightIcon={<ChevronDownIcon />}
                                >
                                    <Flex alignItems="center">
                                        {selectedCreator?.name && <Image src={selectedCreator.image ?? "/assets/resources/emptyProfile.png"} w="6" h="6" rounded="full" />}
                                        <Text noOfLines={1} wordBreak="break-all" w="120px" ml={selectedCreator?.name ? 2 : 0}>{selectedCreator?.name ? selectedCreator?.name : "All creators"}</Text>
                                    </Flex>
                                </MenuButton>
                                <MenuList maxH="215px" overflow="scroll">
                                    <MenuItem
                                        as={Box}
                                        key={"creator"}
                                        onClick={() => {
                                            setSelectedCreator({});
                                        }}
                                    >
                                        All clients
                                    </MenuItem>
                                    {clients?.map((creator, index) => (
                                        <MenuItem
                                            as={Box}
                                            key={"creator-" + index}
                                            onClick={() => {
                                                setSelectedCreator(creator);
                                            }}
                                        >
                                            <CreatorListItem creator={creator} index={index} />
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </Menu>
                            {
                                !!selectedCreatorContract && (
                                    <Button as="a" href="/ghostwriter?tab=My+contracts"
                                        variant="outline"
                                    >
                                        Contract
                                    </Button>
                                )
                            }
                            {
                                !!selectedCreatorContract?.contentPlanUrl && (
                                    <Button as="a" 
                                        ml={2}
                                        href={selectedCreatorContract?.contentPlanUrl}
                                        target="_blank"
                                        variant="outline"
                                    >
                                        Content Plan
                                    </Button>
                                )
                            }
                        </Flex>
                        <Flex>
                            {
                                selectedCreator?.id && (
                                    <Button
                                        variant="ghost"
                                        color="gray.500"
                                        fontWeight={400}
                                        as="a"
                                        target="_blank"
                                        href={"https://app.taplio.com/write?handle=" + selectedCreator?.twUserName}
                                    >
                                        + write for {name}
                                    </Button>
                                )
                            }
                        </Flex>
                    </Flex>
                )
            }
            {
                tweetsFiltered?.length > 0 && (
                    <Flex flexDir="column">
                        {
                            tweetsFiltered.map((tweet) => (
                                <TweetBar
                                    key={tweet.id}
                                    type="ghost"
                                    tweet={tweet}
                                    isGhostwriter={true}
                                    disableGhostInfo={true}
                                />
                            ))
                        }
                    </Flex>
                )
            }
            {
                isLoading ? (
                    <Center pt={20} w="100%">
                        <PuffLoader color={"#0A66C2"} loading={isLoading}
                            cssOverride={{
                                display: "block",
                                margin: "0 auto",
                                borderColor: "red",
                            }} size={50}
                        />
                    </Center>
                ) : (
                    tweetsFiltered?.length == 0 && (
                        !!selectedCreator?.twUserName ? (
                            <Center flexDir="column">
                                <Text mt={20}>No content found for this client, start writing for them</Text>
                                <Button
                                    mt={5}
                                    variant="primary"
                                    fontWeight={400}
                                    as="a"
                                    target="_blank"
                                    href={"https://app.taplio.com/write?handle=" + selectedCreator?.twUserName}
                                >
                                    write for <Text as="span" fontWeight={600} ml={1}>{name}</Text>
                                </Button>
                            </Center>
                        ) : (
                            <Center>
                                <Text mt={20}>No content found</Text>
                            </Center>
                        )
                    )
                )
            }
        </Box>
    );
};  
